<app-header></app-header>
<div class="custom_scrollbar">
  <div>
    <!-- Hero Section -->

    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 4rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3">
              <i class="bi bi-bag-check"></i> Shopify Stores
            </span>
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                24/7 AI Assistant for Your Online Store
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                <strong>ConnectNow</strong> helps Shopify businesses enhance
                buyer confidence, track orders in real-time, and provide
                seamless live support — ensuring higher conversions and happier
                customers.
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="
                  accelerometer;
                  autoplay;
                  clipboard-write;
                  encrypted-media;
                  gyroscope;
                  picture-in-picture;
                  web-share;
                "
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <!-- Key Features Section -->
    <section id="features" class="py-5">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="fw-bold">Key Features for Shopify Stores</h2>
          <p class="text-secondary mb-0">
            Powerful AI-driven tools that increase sales, streamline support,
            and boost customer trust.
          </p>
        </div>

        <div class="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-4">
          <!-- Feature 1 -->
          <div class="col">
            <div
              class="card h-100 text-center shadow-sm border-0 rounded-4 p-4 feature-card"
            >
              <div class="feature-icon bg-success text-white mx-auto mb-3">
                <i class="bi bi-question-circle fs-3"></i>
              </div>
              <h5 class="fw-bold mb-2">Instant Product Q&A</h5>
              <p class="text-secondary mb-0">
                AI answers customer questions instantly to build confidence and
                reduce cart abandonment.
              </p>
            </div>
          </div>

          <!-- Feature 2 -->
          <div class="col">
            <div
              class="card h-100 text-center shadow-sm border-0 rounded-4 p-4 feature-card"
            >
              <div class="feature-icon bg-info text-white mx-auto mb-3">
                <i class="bi bi-truck fs-3"></i>
              </div>
              <h5 class="fw-bold mb-2">Real-Time Order Tracking</h5>
              <p class="text-secondary mb-0">
                Let customers track orders via chat, reducing repetitive
                inquiries and improving satisfaction.
              </p>
            </div>
          </div>

          <!-- Feature 3 -->
          <div class="col">
            <div
              class="card h-100 text-center shadow-sm border-0 rounded-4 p-4 feature-card"
            >
              <div class="feature-icon bg-warning text-dark mx-auto mb-3">
                <i class="bi bi-calendar-event fs-3"></i>
              </div>
              <h5 class="fw-bold mb-2">Scheduling Integration</h5>
              <p class="text-secondary mb-0">
                Enable buyers to book demos, consultations, or deliveries with
                one click.
              </p>
            </div>
          </div>

          <!-- Feature 4 -->
          <div class="col">
            <div
              class="card h-100 text-center shadow-sm border-0 rounded-4 p-4 feature-card"
            >
              <div class="feature-icon bg-danger text-white mx-auto mb-3">
                <i class="bi bi-headset fs-3"></i>
              </div>
              <h5 class="fw-bold mb-2">Live Agent Handover</h5>
              <p class="text-secondary mb-0">
                Seamlessly transfer complex cases from AI to human agents with
                full context.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
